var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-status"},[_c('span',{staticClass:"status",class:_vm.item.status},[_vm._v(" "+_vm._s(_vm.$t('project.status.' + _vm.item.status))+" "),(_vm.showDate)?_c('span',[_vm._v(" "+_vm._s(_vm.finishDate)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }